import React from 'react';

interface PagerDutyIconProps {
  size?: number;
  className?: string;
  color?: string;
}

const PAGERDUTY_GREEN = '#06AC38';
const PAGERDUTY_BLUE = '#0052cc';
const GRAY_DEFAULT = '#A0AEC0';

export const PagerDutyIcon: React.FC<PagerDutyIconProps> = ({
  size = 24,
  className,
  color,
}) => {
  // Determine the state based on color
  const isCompleted = color === PAGERDUTY_GREEN;
  const isInProgress = color === PAGERDUTY_BLUE;
  const isGray = color === GRAY_DEFAULT;

  // Apply filters based on state
  let filterStyle = 'none';
  let opacityStyle = 1;

  if (isGray) {
    // Gray state: grayscale and dimmed
    filterStyle = 'grayscale(100%) brightness(0.8)';
    opacityStyle = 0.4;
  } else if (isInProgress) {
    // In progress: show in color with full opacity
    filterStyle = 'none';
    opacityStyle = 1;
  } else if (isCompleted) {
    // Completed: show in full color
    filterStyle = 'none';
    opacityStyle = 1;
  }

  return (
    <img
      src="/pagerduty-icon.webp"
      alt="PagerDuty"
      width={size}
      height={size}
      className={className}
      style={{
        display: 'block',
        filter: filterStyle,
        opacity: opacityStyle,
      }}
    />
  );
};
